// Общий выбор преподавателя: карточка препода (фото/цена/телефон/цифры ранга/коммент сопроводителя)
// + сетка свободных окошек на неделю. Один источник для окна записи (TrialSignupModal — звонильщицы,
// переписчицы, сопроводители), окна СМЕНЫ препода и окна СКИДКИ (Антон 11.08, не плодить дубли).
// 17.09: карточка перерисована по макету Антона (crm.ctg.school/preview/_tutor-picker-v2-preview.html):
// фамилия одной строкой, четыре цифры плитками, кнопка выбора и телефон в одной строке.
import { useState, useEffect } from 'react'
import api from '../api'
import { formatTeacherPhone, telHref } from './TrialSignupModal'
import TeacherRating from './TeacherRating'

const MONTHS = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']
const DOW = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']

function mondayIso(base) {
  const d = base ? new Date(base + 'T00:00:00') : new Date()
  const day = d.getDay(), diff = day === 0 ? 6 : day - 1
  d.setDate(d.getDate() - diff)
  return d.toISOString().slice(0, 10)
}
function addDaysIso(iso, n) {
  const d = new Date(iso + 'T00:00:00'); d.setDate(d.getDate() + n)
  return d.toISOString().slice(0, 10)
}
function fmtDay(iso) {
  const d = new Date(iso + 'T00:00:00'); return d.getDate() + ' ' + MONTHS[d.getMonth()]
}

// ── Подсказка «в списке только нужный предмет» ──
// Менеджеры переживали, что при смене препода можно случайно назначить чужой
// предмет (Антон 11.08) — подбор и так фильтрует по предмету брони, здесь
// просто говорим об этом явно. Общая для окон звонильщицы и сопроводителя.
export function TutorPickerSubjectHint({ subject, grade }) {
  if (!subject) return null
  const g = String(grade || '').trim()
  const gradeText = g ? (/^\d+$/.test(g) ? ` для ${g} класса` : ` · уровень ${g}`) : ''
  return (
    <div className="text-[11.5px] mb-2" style={{ color: '#0369A1' }}>
      Показаны только преподаватели по предмету «{subject}»{gradeText}
    </div>
  )
}

// ── Приоритет препода для менеджера (платформа teacher_rank, Антон 05.09) ──
// Подписи — языком менеджера, цифрами «N из M», без процентов и терминов.
const CHIP = {
  base: { display: 'inline-block', padding: '2px 8px', borderRadius: 999, border: '1px solid #E2E8F0', background: '#F8FAFC', color: '#334155', fontWeight: 700, fontSize: 11 },
  good: { background: '#ECFDF5', color: '#047857', borderColor: '#A7F3D0' },
  warn: { background: '#FEFCE8', color: '#A16207', borderColor: '#FDE68A' },
  bad:  { background: '#FEF2F2', color: '#B91C1C', borderColor: '#FECACA' },
  new:  { background: '#EEF2FF', color: '#4338CA', borderColor: '#C7D2FE', fontWeight: 800 },
  gray: { background: '#F1F5F9', color: '#64748B', borderColor: '#E2E8F0' },
}
function Chip({ kind, children }) { return <span style={{ ...CHIP.base, ...(kind ? CHIP[kind] : {}) }}>{children}</span> }
export function pluralRu(n, one, few, many) { const m10 = n % 10, m100 = n % 100; return m10 === 1 && m100 !== 11 ? one : (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) ? few : many }

// Цветная точка у цифры: зелёная — хорошо, жёлтая — так себе, серая — данных мало / нейтрально.
const DOT = { g: '#10b981', y: '#f59e0b', r: '#ef4444', n: '#cbd5e1' }
function Stat({ dot, value, label }) {
  return (
    <div style={{ background: '#F8FAFC', border: '1px solid #EEF2F7', borderRadius: 10, padding: '6px 8px', minWidth: 0 }}>
      <div style={{ fontSize: 14, fontWeight: 800, color: '#0F172A', display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: DOT[dot] || DOT.n, flexShrink: 0 }} />{value}
      </div>
      <div style={{ fontSize: 10.5, color: '#64748B', marginTop: 1, lineHeight: 1.2 }}>{label}</div>
    </div>
  )
}

// Старая строка плашек ранга — оставлена для совместимости (в карточке больше не используется).
export function TutorRankLine({ rank }) {
  if (!rank) return null
  const r = rank
  const slotsKind = r.free_slots >= 30 ? 'good' : r.free_slots > 0 ? 'warn' : 'bad'
  const convKind = r.conv_pct == null ? null : r.conv_pct >= 70 ? 'good' : r.conv_pct >= 50 ? 'warn' : 'bad'
  return (
    <div className="mt-2 flex flex-wrap gap-1.5 items-center">
      <Chip kind={slotsKind}>{r.free_slots > 0 ? `Свободных окон на неделе: ${r.free_slots}` : 'Окна на неделю не открыты'}</Chip>
      <Chip kind={convKind}>{r.conv_pct != null ? `Остались ${r.conv_stayed} из ${r.conv_came} первых учеников` : 'Первых уроков ещё не было'}</Chip>
      <Chip kind={r.students <= 1 ? 'warn' : null}>Сейчас учеников: {r.students}</Chip>
      {r.crm_floor && <span className="text-[11px] font-bold" style={{ color: '#98A2B3' }}>{r.crm_floor}</span>}
    </div>
  )
}

// Кратко про классы: «5, 6, 7, 8, ОГЭ, ЕГЭ» → «5–8, ОГЭ, ЕГЭ»
function shortLevels(arr) { return shortClasses({ classLevels: arr || [] }) }
// Классы по каждому предмету из анкеты (28.09.2026): «Математика: 4–7, ОГЭ · Русский язык: 5–8, ЕГЭ»; старые анкеты — общий список
function subjectLevelsLine(t) {
  const sl = t.subject_levels && typeof t.subject_levels === 'object' ? t.subject_levels : null
  if (!sl || !Object.keys(sl).length) return shortClasses(t) ? 'Классы: ' + shortClasses(t) : null
  return null   // классы по предмету — отдельным блоком ниже (Антон 29.09: предметы и программы раздельно)
}
const TZ_LABEL = { 'Europe/Kaliningrad': 'Калининград (МСК−1)', 'Europe/Moscow': 'Москва (МСК)', 'Europe/Samara': 'Самара (МСК+1)', 'Asia/Yekaterinburg': 'Екатеринбург (МСК+2)', 'Asia/Omsk': 'Омск (МСК+3)', 'Asia/Krasnoyarsk': 'Красноярск (МСК+4)', 'Asia/Irkutsk': 'Иркутск (МСК+5)', 'Asia/Yakutsk': 'Якутск (МСК+6)', 'Asia/Vladivostok': 'Владивосток (МСК+7)', 'Asia/Magadan': 'Магадан (МСК+8)', 'Asia/Kamchatka': 'Камчатка (МСК+9)' }
function shortClasses(t) {
  const lv = (t.classLevels || []).map(x => String(x).trim()).filter(Boolean)
  if (!lv.length) return t.classes ? String(t.classes).replace(/^Классы и уровни:\s*/i, '') : ''
  const nums = lv.filter(x => /^\d+$/.test(x)).map(Number).sort((a, b) => a - b)
  const rest = lv.filter(x => !/^\d+$/.test(x))
  const parts = []
  let i = 0
  while (i < nums.length) {
    let j = i
    while (j + 1 < nums.length && nums[j + 1] === nums[j] + 1) j++
    parts.push(j - i >= 2 ? `${nums[i]}–${nums[j]}` : nums.slice(i, j + 1).join(', '))
    i = j + 1
  }
  return parts.concat(rest).join(', ')
}

// ── Карточка препода ──
// actionLabel — подпись кнопки выбора («Выбрать · чт 18:00»); actionDisabled — время ещё не выбрано.
export function TutorPickerCard({ t, selected, onClick, atSlotFree, onProfile, actionLabel, actionDisabled, showFirstLessonLabel }) {
  const waiting = !!(t.otbor && t.otbor.waiting)
  const r = t.rank || null
  const onFloor = !!(r && r.crm_floor)
  const slotsDot = !r ? 'n' : r.free_slots >= 30 ? 'g' : r.free_slots > 0 ? 'y' : 'r'
  const convDot = !r || r.conv_pct == null ? 'n' : r.conv_pct >= 70 ? 'g' : r.conv_pct >= 50 ? 'y' : 'r'
  const phone = formatTeacherPhone(t.phone)
  const subline = [
    subjectLevelsLine(t),
    t.experience ? 'стаж ' + t.experience : null,
    r && r.resp_min != null ? `отвечает за ${r.resp_min} мин` : null,
  ].filter(Boolean).join(' · ')
  return (
    <div onClick={onClick}
      className={'relative rounded-2xl border p-3.5 transition ' + (selected ? '' : 'border-slate-200 hover:bg-slate-50') + (onClick ? ' cursor-pointer' : '')}
      style={{ ...(selected ? { background: '#F0F9FF', boxShadow: 'inset 0 0 0 2px #38BDF8', borderColor: 'transparent' } : {}), ...(onFloor && !selected ? { opacity: 0.65, background: '#F8FAFC' } : {}) }}>
      {waiting && (
        <div className="inline-flex items-center gap-1 text-[10.5px] font-extrabold px-2.5 py-1 rounded-full mb-2"
          style={{ background: '#EEF2FF', color: '#4338CA', border: '1px solid #C7D2FE' }}>↑ Прошёл отбор · ждёт пробников</div>
      )}
      <div className="flex items-start gap-3">
        {t.photo
          ? <img src={`/platform-photo/${t.mkId}`} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = 'none' }}
              className="w-14 h-14 rounded-xl object-cover shrink-0" style={{ background: '#F1F5F9' }} />
          : <div className="w-14 h-14 rounded-xl shrink-0" style={{ background: '#F1F5F9' }} />}
        <div className="min-w-0 flex-1">
          <div className="text-[14px] font-bold text-slate-900 leading-tight flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>{t.name}</span>
            {t.age != null && <span className="text-[10.5px] font-bold px-1.5 py-0.5 rounded-full"
              style={{ background: '#E0F2FE', color: '#0369A1', border: '1px solid #BAE6FD' }}>{t.age} {pluralRu(t.age, 'год', 'года', 'лет')}</span>}
            <TeacherRating mkId={t.mkId} rating={t.rating} reviewCount={t.reviewCount} style={{ marginLeft: 0 }} />
            {showFirstLessonLabel && (t.firstLessonPrice || typeof t.isLeader === 'boolean') && (
              <span style={{ fontSize: 10.5, fontWeight: 700, whiteSpace: 'nowrap', color: (t.firstLessonPrice || t.isLeader) ? '#047857' : '#A16207' }}>
                {t.firstLessonPrice ? ('Первый урок ' + t.firstLessonPrice + ' ₽') : (t.isLeader ? 'Первый урок бесплатный' : 'Первый урок платный')}
              </span>
            )}
          </div>
          {subline && <div className="text-[11.5px] text-slate-500 mt-1">{subline}</div>}
        </div>
        {t.price != null && <span className="text-[12px] font-extrabold px-2.5 py-0.5 rounded-full whitespace-nowrap shrink-0"
          style={{ background: '#ECFDF5', color: '#047857', border: '1px solid #A7F3D0' }}>{t.price} ₽ / урок</span>}
      </div>

      {r && (
        <div className="grid gap-1.5 mt-2.5" style={{ gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
          <Stat dot={slotsDot} value={r.free_slots > 0 ? r.free_slots : '0'} label="окон на неделе" />
          <Stat dot={convDot} value={r.conv_came >= 3 ? `${r.conv_stayed} из ${r.conv_came}` : (r.conv_came > 0 ? `${r.conv_stayed} из ${r.conv_came}` : '—')}
            label={r.conv_came >= 3 ? 'остались после первого урока' : (r.conv_came > 0 ? 'остались · для оценки нужно 3' : 'первых уроков ещё не было')} />
          <Stat dot={r.students <= 1 ? 'y' : 'n'} value={r.students} label={r.students <= 1 ? 'учеников сейчас, можно грузить' : 'учеников сейчас'} />
          <Stat dot="n" value={r.lessons_30d || 0} label="уроков за 30 дней" />
        </div>
      )}

      {(r && (r.penalty > 0 || r.is_newbie || r.crm_floor)) && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {r.penalty > 0 && <Chip kind="bad">Бывают поздние отмены и переносы</Chip>}
          {r.is_newbie && <Chip kind="new">Новый на платформе{r.days != null ? `, ${r.days} дн` : ''}. Нужны первые ученики</Chip>}
          {r.crm_floor && <Chip kind="gray">{r.crm_floor}</Chip>}
        </div>
      )}
      {atSlotFree === false && <div className="text-[11.5px] font-semibold mt-2" style={{ color: '#98A2B3' }}>Занят(а) в это время</div>}
      {atSlotFree === true && <div className="text-[11.5px] font-bold mt-2" style={{ color: '#047857' }}>Свободен(на) в это время</div>}
      {t.otbor && t.otbor.note && (
        <div className="text-[11.5px] leading-snug text-slate-600 mt-2.5"
          style={{ borderLeft: '2px solid #38BDF8', background: '#F8FAFC', borderRadius: '0 8px 8px 0', padding: '6px 10px' }}>
          <b className="text-slate-700">Сопроводитель:</b> {t.otbor.note}
        </div>
      )}
      {(() => {
        const sl = t.subject_levels && typeof t.subject_levels === 'object' && Object.keys(t.subject_levels).length ? t.subject_levels : null
        const pr = t.programs && typeof t.programs === 'object' ? t.programs : {}
        const hasExtra = !!(t.timezone || t.education || (t.lesson_format && t.lesson_format.offline))
        if (!sl && !hasExtra) return null
        const Row = ({ label, children }) => <div className="flex flex-wrap items-center gap-1.5 mt-1"><span className="text-[11px] font-extrabold" style={{ color: '#64748B' }}>{label}</span>{children}</div>
        return (
          <div className="mt-2.5">
            {sl && <div className="text-[11px] font-extrabold" style={{ color: '#64748B' }}>Предметы, классы и программы</div>}
            {sl && Object.keys(sl).map(subj => (
              <div key={subj} className="rounded-[10px] px-2 py-1.5 mt-1.5" style={{ border: '1px solid #EEF2F7', background: '#FCFDFE' }}>
                <div className="text-[12px] font-extrabold text-slate-900">{subj}</div>
                <Row label="Классы">{(shortLevels(sl[subj]) || '—').split(', ').map(x => <Chip key={x}>{x}</Chip>)}</Row>
                {(pr[subj] || []).length > 0 && <Row label="Программы">{pr[subj].map(x => <Chip key={x} kind="gray">{x}</Chip>)}</Row>}
              </div>
            ))}
            {t.timezone && <Row label="Часовой пояс"><Chip kind={t.timezone === 'Europe/Moscow' ? null : 'warn'}>{TZ_LABEL[t.timezone] || t.timezone}</Chip></Row>}
            {t.lesson_format && t.lesson_format.offline && <Row label="Формат"><Chip>онлайн</Chip><Chip>офлайн{t.lesson_format.city ? ' · ' + t.lesson_format.city : ''}</Chip></Row>}
            {t.education && <Row label="Образование"><span className="text-[11.5px] text-slate-600">{t.education}</span></Row>}
          </div>
        )
      })()}
      <div className="flex items-center gap-2.5 mt-2.5">
        {(onClick || actionLabel) && (
          <button onClick={(e) => { e.stopPropagation(); if (!actionDisabled && onClick) onClick() }} disabled={!!actionDisabled}
            className="inline-flex items-center text-[12px] font-bold rounded-lg px-3 py-1.5"
            style={selected
              ? { color: '#fff', background: '#0369A1', border: '1px solid #0369A1' }
              : actionDisabled
                ? { color: '#94A3B8', background: '#F8FAFC', border: '1px solid #E2E8F0', cursor: 'default' }
                : { color: '#fff', background: '#38BDF8', border: '1px solid #38BDF8' }}>
            {selected ? 'Выбран(а)' + (actionLabel ? actionLabel.replace(/^Выбрать/, '') : '') : (actionLabel || 'Выбрать')}
          </button>
        )}
        {onProfile && (
          <button onClick={(e) => { e.stopPropagation(); onProfile() }}
            className="inline-flex items-center text-[12px] font-semibold rounded-lg px-3 py-1.5"
            style={{ color: '#0369A1', background: '#fff', border: '1px solid #BAE6FD' }}>Карточка</button>
        )}
        {phone && (
          <a href={telHref(t.phone)} onClick={(e) => e.stopPropagation()}
            className="ml-auto text-[12.5px] font-bold text-slate-700 whitespace-nowrap">{phone}</a>
        )}
      </div>
    </div>
  )
}

// ── Свободные окошки препода на неделю ──
export function TutorWeekSlots({ mkId, lessonDate, lessonTime, value, onChange, title, hint }) {
  const [weekStart, setWeekStart] = useState(mondayIso(lessonDate))
  const [slots, setSlots] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    let alive = true; setLoading(true); setSlots(null)
    api.get(`/api/platform/tutors/${mkId}/slots`, { params: { dateFrom: weekStart, dateTo: addDaysIso(weekStart, 6) } })
      .then(r => { if (alive) setSlots(r.data.slots || {}) })
      .catch(() => { if (alive) setSlots({}) })
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [mkId, weekStart])
  const days = Array.from({ length: 7 }, (_, i) => addDaysIso(weekStart, i))
  const lt = String(lessonTime || '').slice(0, 5)
  return (
    <div className="rounded-2xl border border-slate-200 p-3.5" style={{ background: '#FCFDFE' }}>
      <div className="flex items-center justify-between mb-1">
        <div className="text-[13px] font-extrabold text-slate-800">{title || 'Свободные окошки'}</div>
        <div className="flex items-center gap-2 text-[12px] font-bold text-slate-500">
          <button onClick={() => setWeekStart(addDaysIso(weekStart, -7))} className="w-6 h-6 rounded-md border border-slate-200 bg-white">‹</button>
          <span>{fmtDay(days[0])} – {fmtDay(days[6])}</span>
          <button onClick={() => setWeekStart(addDaysIso(weekStart, 7))} className="w-6 h-6 rounded-md border border-slate-200 bg-white">›</button>
        </div>
      </div>
      <p className="text-[11.5px] mb-3" style={{ color: '#98A2B3' }}>{hint || 'Если текущее время не подходит — выберите другое свободное окно, урок перенесётся сам.'}</p>
      {loading && <div className="text-[12px] text-slate-400 py-4 text-center">Загрузка окошек…</div>}
      {!loading && (
        <div className="flex flex-col gap-1.5">
          {days.map(iso => {
            const times = (slots && slots[iso]) || []
            const isLessonDay = !!lessonTime && iso === lessonDate
            return (
              <div key={iso} className="grid items-start gap-2.5" style={{ gridTemplateColumns: '58px 1fr' }}>
                <div className="text-[11.5px] font-bold pt-1" style={{ color: isLessonDay ? '#0369A1' : '#667085' }}>
                  {DOW[(new Date(iso + 'T00:00:00').getDay() + 6) % 7]}
                  <span className="block text-[10px] font-semibold" style={{ color: '#98A2B3' }}>{fmtDay(iso)}</span>
                  {isLessonDay && <span className="inline-block mt-0.5 text-[9.5px] font-extrabold px-1.5 rounded-full"
                    style={{ color: '#0369A1', background: '#E0F2FE', border: '1px solid #BAE6FD' }}>урок</span>}
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {times.length === 0 && <span className="text-[11.5px] px-2.5 py-1 rounded-lg" style={{ border: '1px dashed #E2E8F0', color: '#98A2B3' }}>нет окон</span>}
                  {times.map(tm => {
                    const isCurrent = isLessonDay && tm === lt
                    const isSel = value && value.date === iso && value.time === tm
                    const style = isSel
                      ? { background: '#38BDF8', color: '#fff', border: '1px solid #38BDF8' }
                      : isCurrent
                        ? { background: '#E0F2FE', color: '#0369A1', border: '1px solid #7DD3FC' }
                        : { background: '#F0F9FF', color: '#0369A1', border: '1px solid #BAE6FD' }
                    return <button key={tm} onClick={() => onChange({ date: iso, time: tm })}
                      className="text-[11.5px] font-bold px-2.5 py-1 rounded-lg" style={style}>{tm}</button>
                  })}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
